import React, { Component } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, DropdownItem, DropdownToggle, DropdownMenu, Nav, UncontrolledDropdown } from 'reactstrap';
import { NavLink as Link, withRouter } from 'react-router-dom';
import { api_url } from "./globalFunction/global_string";
import './NavMenu.css';
import './TotalCss.css';
import Swal from 'sweetalert2';
import { loginInfo } from "./globalFunction/global_string";

export class NavMenu extends Component {
  static displayName = NavMenu.name;
  constructor(props) {
    super(props);
    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.WebtoggleDropdown = this.WebtoggleDropdown.bind(this);
    this.toggleBackDropDownOpen = this.toggleBackDropDownOpen.bind(this);
    this.clearLocalStorage = this.clearLocalStorage.bind(this);
    this.state = {
      collapsed: true,
      dropdownOpen: false,
      backDropDownOpen: false,
      WebDropDownOpen: false,
      loggedIn: localStorage.getItem('login_state') === 'true',
      accessToken: localStorage.getItem('accessToken') || false,
      tenablePage: loginInfo.tenable_page || false,
    };
  }

  componentDidMount() {
    // 確認是否已經登入
    if (this.state.loggedIn === true || this.state.loggedIn === 'true') {
      const loginTimeStr = localStorage.getItem('login_time');
      const currentTime = new Date();

      // 檢查是否超過8小時，以便進行自動登出
      if (loginTimeStr) {
        const loginTime = new Date(loginTimeStr);

        // 檢查是否超過8小時
        // if (currentTime - loginTime > 10 * 60 * 60 * 1000) {
        //   this.refreshAccessToken();
        //   return;
        // }
        if (currentTime - loginTime > 10 * 60 * 60 * 1000) {
          Swal.fire({
            title: '超時登出',
            text: '您已超過 10 小時未操作，系統將自動登出。',
            icon: 'warning',
            confirmButtonText: '確定'
          }).then(() => {
            // 確定後執行登出操作
            this.clearLocalStorage(true);
          });
          return;
        }
      } else {
        // 如果未超過10小時，則進行帳號開通狀態的檢查
        let api = api_url + "/api/Auth/userinfo";
        fetch(api, {
          method: "GET",
          headers: {
            "Authorization": localStorage.getItem('accessToken'),
          },
        })
          .then(response => response.json())
          .then(data => {
            let arr_status = [String(data.statusCode), data.row, data.detail];
            console.log(data)
            // 如果帳號未開通，顯示待開通提示
            if (arr_status[1] === undefined) {
              Swal.fire({
                icon: 'info',
                title: '待開通',
                text: '管理者尚未開通此帳號權限，開通後系統會以Email通知登入。'
              });
            } else {
              // 儲存用戶資訊到localStorage
              localStorage.setItem('login_user_type', arr_status[1].user_type);
              localStorage.setItem('login_user_id', arr_status[1].user_id);
              localStorage.setItem('login_user_name', arr_status[1].user_name);
              localStorage.setItem('login_user_net_id', arr_status[1].local_net_id);
              localStorage.setItem('login_user_unit_id', arr_status[1].local_unit_id);
              localStorage.setItem('login_user_net_name', arr_status[1].local_net_name);
              localStorage.setItem('login_local_unit_name', arr_status[1].local_unit_name);
              localStorage.setItem('registrationStatus', arr_status[1].registrationStatus);
              localStorage.setItem('tenable_page', arr_status[1].tenable_page);
              // 更新登入時間
              const loginTime = new Date().toString();
              localStorage.setItem('login_time', loginTime);

              // 設置自動登出計時器
              const logoutTimer = setTimeout(() => {
                this.clearLocalStorage(true);
              }, 10 * 60 * 60 * 1000);

              // 更新組件狀態
              this.setState({
                loggedIn: true,
                logoutTimerId: logoutTimer,
                tenablePage: arr_status[1].tenable_page
              });
            }
          })
          .catch(error => {
            console.error('Error:', error);
          });
      }
    }
    // 更新導航欄狀態
    this.updateNavbarState();
    // 添加視窗調整大小事件監聽器
    window.addEventListener('resize', this.updateNavbarState);
  }

  componentWillUnmount() {
    window.removeEventListener('loginUserNameChanged', this.handleLoginUserNameChanged);
    if (this.state.logoutTimerId) {
      clearTimeout(this.state.logoutTimerId);
    }
    window.removeEventListener('resize', this.updateNavbarState);
  }

  handleLoginUserNameChanged = () => {
    const login_name = localStorage.getItem("login_user_name") || 'guest';
    this.setState({ login_name });
  };


  toggleBackDropDownOpen() {
    this.setState({
      backDropDownOpen: !this.state.backDropDownOpen
    });
  }
  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  WebtoggleDropdown() {
    this.setState({
      WebDropDownOpen: !this.state.WebDropDownOpen
    });
  }
  //判斷10小時的時候自動登出
  clearLocalStorage = (autoLoggedOut = false) => {
    localStorage.clear();
    if (this.state.logoutTimerId) {
      clearTimeout(this.state.logoutTimerId);
    }

    if (autoLoggedOut) {
      // 自動登出的邏輯
      window.location.href = '/';
    }
    this.setState({
      loggedIn: false,
      logoutTimerId: null,
    });
  };


  //手動按登出使用
  logoutclearLocalStorage = () => {
    localStorage.clear();
    Swal.fire({
      title: '登出',
      text: '您已成功登出系统。',
      icon: 'info',
      confirmButtonText: '確定'
    }).then(() => {
      window.location.href = '/';
    });

    this.setState({
      loggedIn: false,
      logoutTimerId: null,
    });
  };

  refreshAccessToken() {
    let api = api_url + "/api/Auth/refresh";
    fetch(api, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": localStorage.getItem('refToken'), // 使用 refresh token
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.accessToken) {
          // 更新 access token 和登入時間
          localStorage.setItem('accessToken', data.accessToken);
          localStorage.setItem('login_time', new Date().toString());
        } else {
          this.clearLocalStorage(true);
        }
      })
      .catch(error => {
        console.error('Error:', error);
        this.clearLocalStorage(true);
      });
  }


  updateNavbarState = () => {
    // 根據螢幕寬度設定collapsed狀態
    const screenWidth = window.innerWidth;
    if (screenWidth >= 768) {
      this.setState({ collapsed: true });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    // 當 tenablePage 狀態改變時，執行相應的邏輯
    if (prevState.tenablePage !== this.state.tenablePage) {
      console.log('tenablePage has been updated:', this.state.tenablePage);
    }
  }


  toggleNavbar = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 768) {
      this.setState(prevState => ({
        collapsed: !prevState.collapsed
      }));
    }
  };

  render() {
    const isLoggedIn = this.state.loggedIn;
    const login_user_type = localStorage.getItem("login_user_type") || 'guest';
    const login_name = localStorage.getItem("login_user_name") || 'guest';
    const net_name = localStorage.getItem("login_user_net_name") || '';
    const unit_name = localStorage.getItem("login_local_unit_name") || '';
    const { collapsed } = this.state;


    const getNavStyle = (isStart) => {
      const isNarrowScreen = window.innerWidth <= 1023;
      if (isNarrowScreen) {
        return { display: 'flex', justifyContent: isStart ? 'flex-start' : 'flex-end', width: '100%' };
      } else {
        return {
          display: 'flex',
          justifyContent: isStart ? 'flex-start' : 'flex-end',
          width: '100%',

        };
      }
    };

    return (
      <header>
        <Navbar light expand="md">
          <NavbarBrand className="px-0" tag={Link} to='/'>
            <img src="/nymctu_fontpage_logo_s.png" alt="NYMCTU_CIA" />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggleNavbar} />
          <Collapse isOpen={!collapsed} navbar>
            <Nav navbar style={getNavStyle(true)}>
              <UncontrolledDropdown nav inNavbar isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown}>
                <DropdownToggle nav caret>
                  弱點偵測
                </DropdownToggle>
                <DropdownMenu>
                  {login_user_type === 'N' ? (
                    <>
                      {/* <DropdownItem tag={Link} activeClassName="active" to="/webScanBackground">網站弱點偵測</DropdownItem>
                      <DropdownItem tag={Link} activeClassName="active" to="/HostBackground">主機弱點偵測</DropdownItem>
                      <DropdownItem tag={Link} activeClassName="active" to="/cia-scanner/cia-site-list">網站結果查詢</DropdownItem> */}
                      <DropdownItem tag={Link} activeClassName="active" to="/webScanApplication">檢測主機與網站申請</DropdownItem>
                      <DropdownItem tag={Link} activeClassName="active" to="/hostAndWebsiteScan">檢測主機與網站掃描</DropdownItem>
                      <DropdownItem tag={Link} activeClassName="active" to="/websiteScanResults">檢測網站結果查詢</DropdownItem>
                      {this.state.tenablePage && (
                        <DropdownItem tag={Link} activeClassName="active" to="/hostScanResults">檢測主機結果查詢</DropdownItem>
                      )}
                      {/* <DropdownItem tag={Link} activeClassName="active" to="/cia-scanner/cia-statistical">檢測數量統計</DropdownItem> */}
                    </>
                  ) : login_user_type === 'M' && (isLoggedIn === true || isLoggedIn === 'true') ? (
                    <>
                      {/* <DropdownItem tag={Link} activeClassName="active" to="/cia-scanner/cia-site-manage">檢測網站匯入</DropdownItem>
                      <DropdownItem tag={Link} activeClassName="active" to="/cia-scanner/cia-apply">檢測網站申請</DropdownItem>
                      <DropdownItem tag={Link} activeClassName="active" to="/websiteScanResults">檢測結果查詢</DropdownItem> */}

                      <DropdownItem tag={Link} activeClassName="active" to="/webScanApplication">檢測主機與網站申請</DropdownItem>
                      <DropdownItem tag={Link} activeClassName="active" to="/hostAndWebsiteScan">檢測主機與網站掃描</DropdownItem>
                      <DropdownItem tag={Link} activeClassName="active" to="/websiteScanResults">檢測網站結果查詢</DropdownItem>
                      {this.state.tenablePage && (
                        <DropdownItem tag={Link} activeClassName="active" to="/hostScanResults">檢測主機結果查詢</DropdownItem>
                      )}
                    </>
                  ) : login_user_type === 'S' && (isLoggedIn === true || isLoggedIn === 'true') ? (
                    <>
                      {/* <DropdownItem tag={Link} activeClassName="active" to="/cia-scanner/cia-site-manage">檢測網站匯入</DropdownItem>
                      <DropdownItem tag={Link} activeClassName="active" to="/cia-scanner/cia-apply">檢測網站申請</DropdownItem>
                      <DropdownItem tag={Link} activeClassName="active" to="/cia-scanner/cia-site-list">檢測結果查詢</DropdownItem> */}
                      <DropdownItem tag={Link} activeClassName="active" to="/webScanApplication">檢測主機與網站申請</DropdownItem>
                      <DropdownItem tag={Link} activeClassName="active" to="/hostAndWebsiteScan">檢測主機與網站掃描</DropdownItem>
                      <DropdownItem tag={Link} activeClassName="active" to="/websiteScanResults">檢測網站結果查詢</DropdownItem>
                      {this.state.tenablePage && (
                        <DropdownItem tag={Link} activeClassName="active" to="/hostScanResults">檢測主機結果查詢</DropdownItem>
                      )}
                      {/* <DropdownItem tag={Link} activeClassName="active" to="/cia-scanner/cia-statistical">檢測數量統計</DropdownItem> */}
                    </>
                  ) : (<>Guest, 請先登入</>)
                  }
                </DropdownMenu>
              </UncontrolledDropdown>


              {(isLoggedIn === true || isLoggedIn === 'true') && login_user_type !== 'guest' ? (
                <>
                  <UncontrolledDropdown nav inNavbar isOpen={this.state.backDropDownOpen} toggle={this.toggleBackDropDownOpen}>
                    <DropdownToggle nav caret>
                      後臺追蹤
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem tag={Link} activeClassName="active" to="/TrackBackground">
                        網站弱點掃描追蹤
                      </DropdownItem>
                      {login_user_type !== 'N' && (
                        <>
                          <DropdownItem tag={Link} activeClassName="active" to="/WAFBackground">
                            網站WAF追蹤
                          </DropdownItem>
                        </>
                      )}
                      <DropdownItem tag={Link} activeClassName="active" to="/BugBackground">
                        網站漏洞追蹤
                      </DropdownItem>
                      <DropdownItem tag={Link} activeClassName="active" to="/TrackBackground/HistoryTrackBackground">
                        網站漏洞歷史紀錄
                      </DropdownItem>
                      {this.state.tenablePage && (
                        <>
                          <DropdownItem tag={Link} activeClassName="active" to="/HostBackground">主機弱點掃描追蹤</DropdownItem>
                          <DropdownItem tag={Link} activeClassName="active" to="/HostBugBackground">主機漏洞追蹤</DropdownItem>
                          <DropdownItem tag={Link} activeClassName="active" to="/HistoryHostBackground">主機歷史紀錄</DropdownItem>
                        </>
                      )}

                    </DropdownMenu>
                  </UncontrolledDropdown>

                  {(login_user_type === 'M' || login_user_type === 'S') && isLoggedIn && (
                    <UncontrolledDropdown nav inNavbar isOpen={this.state.WebDropDownOpen} toggle={this.WebtoggleDropdown}>
                      <DropdownToggle nav caret>
                        使用者管理權限
                      </DropdownToggle>
                      <DropdownMenu>
                        {login_user_type === 'M' && (
                          <DropdownItem tag={Link} activeClassName="active" to="/cia-scanner/cia-domain-set">使用者網域設定</DropdownItem>
                        )}
                        {login_user_type === 'S' && (
                          <>
                            <DropdownItem tag={Link} activeClassName="active" to="/cia-scanner/cia-user-set">使用者權限設定</DropdownItem>
                            <DropdownItem tag={Link} activeClassName="active" to="/cia-scanner/cia-user-local-Net-set">使用者區網設定</DropdownItem>
                            <DropdownItem tag={Link} activeClassName="active" to="/cia-scanner/cia-local-net-Comparison-Data">使用者區網比對</DropdownItem>
                            <DropdownItem tag={Link} activeClassName="active" to="/cia-scanner/cia-Url-Report-Zip-Password">使用者報告密碼</DropdownItem>
                          </>
                        )}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  )}

                </>
              ) : (
                <>
                </>
              )}



              <NavItem>
                <NavLink tag={Link} activeClassName="active" to="/manual">使用說明</NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} activeClassName="active" to="/cia-info">聯絡資訊</NavLink>
              </NavItem>


            </Nav>
            <Nav navbar style={getNavStyle(false)}>
              {isLoggedIn ? (
                <>
                  {localStorage.getItem("registrationStatus") === "1" ? (
                    <>
                      <NavItem>
                        <NavLink className="txt_area" style={{ display: 'block' }}>
                          區網：{net_name}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink className="txt_area" style={{ display: 'block' }}>
                          單位：{unit_name}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink className="txt_area" style={{ display: 'block' }}>
                          您好，{login_name}
                        </NavLink>
                      </NavItem>
                    </>
                  ) : (
                    <>
                      <NavItem>
                        <NavLink tag={Link} to="/FormModifyinformation" style={{ display: 'block' }} className="txt_area">
                          區網：{net_name}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink tag={Link} to="/FormModifyinformation" style={{ display: 'block' }} className="txt_area">
                          單位：{unit_name}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink tag={Link} to="/FormModifyinformation" style={{ display: 'block' }} className="txt_area">
                          您好，{login_name}
                        </NavLink>
                      </NavItem>
                    </>
                  )}
                  <NavItem>
                    <NavLink tag={Link} onClick={this.logoutclearLocalStorage}>登出</NavLink>
                  </NavItem>
                </>
              ) : (
                <NavItem>
                  <NavLink tag={Link} to="/login">登入</NavLink>
                </NavItem>
              )}
            </Nav>


          </Collapse>
        </Navbar>
      </header>
    );
  }
}
